import { Component, ViewChild, Input, Output, OnChanges, OnInit, SimpleChanges, EventEmitter  } from '@angular/core';
import GatewayDto from '../../dto/gateway-dto';
import { EdgeInterfaceDto, RoutingConfigDto, StaticRouteDto, DefaultRouteDto } from '../../dto/gateway-dto';
const _ = require('lodash');

@Component({
  selector: 'gateway-default-settings',
  template: require('./gateway-default-settings.html')
})

export default class GatewayDefaultSettings {
    @Input('gateway') gateway: GatewayDto;
    @Input('networks') networks: Array<any>;
    @Input('interfaces') interfaces: Array<EdgeInterfaceDto>;
    @Input('routingConfig') routingConfig: RoutingConfigDto;

    @Output('onRouteSettingsChanged') onRouteSettingsChanged = new EventEmitter();
    @Output('onDefaultSettingFormValid') formValid = new EventEmitter();

    @ViewChild('defaultGatewayForm') form;

    private networkName: string = '';
    private defaultGateways: string = '';
    private defaultRouteIndex: string = '0';
    private gatewayAddress: string = '';
    private mtu: string  = '1500';
    private eligibleNetworks: Array<any> = [];
    private routeSettingsChanged: boolean = false;
    private adminDistance: number = 1;

    constructor() {
    }

    onDefaultInterfaceChanged(event) {
      this.routingConfig.staticRouting.defaultRoute.vnic = event;
      this.defaultRouteIndex = event;
      let index = Number(event);
      this.networkName = this.gateway.interfaces[index].networkName;
      this.defaultGateways = this.getDefaultIPs(this.gateway.interfaces[index].networkId);
    }

    onGatewayAddressChanged(gatewayAddress) {
      this.gatewayAddress = gatewayAddress;
      this.routingConfig.staticRouting.defaultRoute.gatewayAddress = gatewayAddress;
    }

    onMtuChanged(mtu) {
      this.mtu = mtu;
      this.routingConfig.staticRouting.defaultRoute.mtu = Number(mtu);
    }

    ngOnChanges(change: SimpleChanges) {
      this.eligibleNetworks = [];
      if (this.gateway) {
        /*if (this.gateway.routingConfig && this.gateway.routingConfig.staticRouting &&
        this.gateway.routingConfig.staticRouting.defaultRoute) {
          this.defaultRouteIndex = this.gateway.routingConfig.staticRouting.defaultRoute.vnic;
          this.gatewayAddress = this.gateway.routingConfig.staticRouting.defaultRoute.gatewayAddress;
          this.mtu = this.gateway.routingConfig.staticRouting.defaultRoute.mtu;
        }*/
        if (this.routingConfig) {
           if ( this.routingConfig.staticRouting &&
            this.routingConfig.staticRouting.defaultRoute) {
              this.defaultRouteIndex = this.routingConfig.staticRouting.defaultRoute.vnic;
              this.gatewayAddress = this.routingConfig.staticRouting.defaultRoute.gatewayAddress;
              this.mtu = String(this.routingConfig.staticRouting.defaultRoute.mtu);
            } else {
              this.routingConfig.staticRouting = new StaticRouteDto();
              this.routingConfig.staticRouting.defaultRoute = new DefaultRouteDto();
            }
        }
      }
      if (this.interfaces && this.interfaces.length > 0) {
        for (let i = 0; i < this.interfaces.length; ++i) {
          let edgeInterface: EdgeInterfaceDto = this.interfaces[i];
          if (edgeInterface.isConnected && typeof edgeInterface.index !== "undefined") {
            this.eligibleNetworks.push({'value': edgeInterface.index.toString(), 'display': edgeInterface.name});
          }
        };
        let index = Number(this.defaultRouteIndex);
        this.networkName = this.gateway.interfaces[index].networkName;
        this.defaultGateways = this.getDefaultIPs(this.gateway.interfaces[index].networkId);
      }
    }

    getDefaultIPs(networkId) {
      if ( networkId === undefined) {
        return '';
      }
      let network = _.find(this.networks, {'objectId': networkId});
      let defaultGateways: string = '';
      if (network && network.ipScopes && network.ipScopes.length > 0) {
        network.ipScopes.map(function(item, index) {
          if (index !== 0) {
            defaultGateways += ',';
          }
          defaultGateways += item.gateway ? item.gateway : 'NA';
          defaultGateways += '/' + item.prefixLength;
        });
      } else {
        defaultGateways = 'Network IP ranges are not mentioned for the network.';
      }
      return defaultGateways;
    }

    changeDefaultSettings(event) {
      this.routeSettingsChanged = !this.routeSettingsChanged;
      this.onRouteSettingsChanged.emit({
        'routeSettingsChanged' : this.routeSettingsChanged
      });
    }

    ngAfterViewInit() {
      this.form.control.valueChanges
      .subscribe(values => this.isFormValid(values));
    }

     isFormValid(values) {
      let isFormValid: boolean;
      if (!this.routeSettingsChanged) {
        isFormValid = true;
      } else {
        isFormValid = this.form.valid;
      }
      this.formValid.emit(
        {
          'isValid': isFormValid
        }
      );
    }
}





// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/gateways/dialogs/wizard-steps/gateway-default-settings.component.ts